var _ = require('underscore');
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="Checkbox js-bounds">\n  <button class="Checkbox-input"></button>\n  <label class="Checkbox-label">Match rows with the map view.</label>\n</div>\n<div class="cartodb-map public">\n  <div class="carto-map" style="height: 100%"></div>\n</div>';

}
return __p
}